module.exports = __webpack_public_path__ + "media/images/icon__externalLink@2x-67d71ca9570c0ccf8685b55017e5b259.png";